import { Component, OnInit, Renderer2, ViewChild, HostListener, ElementRef, Output, EventEmitter, Input } from '@angular/core';

@Component({
  selector: 'app-slider',
  templateUrl: './slider.component.html',
  styleUrls: ['./slider.component.css']
})
export class SliderComponent implements OnInit {

  @Input() title = 'title';
  mouseY = 0;
  mouseIsDown = false;
  handleY = 0;
  lastY = 0;

  @ViewChild('handle') handle: ElementRef;
  @Output() output = new EventEmitter;
  @Input() init = 0;
  @HostListener('document:mousemove', ['$event'])
    public onMove(event) {
      if (this.mouseIsDown) {
        this.move(event.clientY);
        this.mouseY = event.clientY;
//        this.lastY = event.clientY;
      }
    }
  @HostListener('document:mouseup', ['$event'])
    public onUp(event) {
      this.mouseIsDown = false;
    }

  constructor(private renderer: Renderer2) { }

  ngOnInit() {
    const val = -Math.abs(this.init * 100);
    this.handleY = val;
    this.renderer.setStyle(this.handle.nativeElement, 'transform', 'translateY(' + val + 'px)');
  }

  public mouseDown(event) {
        this.mouseY = event.clientY;
        this.mouseIsDown = true;
  }

  onPanStart(event) {
    event.preventDefault();
    this.mouseY = event.center.y;
  }
  onPan(event) {
    event.preventDefault();
    this.move(event.center.y);
  }

  private move(ypos) {
    const diff = ypos - this.mouseY;
    this.handleY += (diff * 0.4);
    if (this.handleY > 0) {
      this.handleY = 0;
    }
    if (this.handleY < (-100)) {
      this.handleY = (-100);
    }
    this.renderer.setStyle(this.handle.nativeElement, 'transform', 'translateY(' + this.handleY + 'px)');
    this.output.emit(Math.abs(this.handleY));
  }

}



// WEBPACK FOOTER //
// ./src/app/slider/slider.component.ts